export default {

  /**
   * 将扁平化的数据转为父子级包含的数据
   * @param {[]} list
   * @returns
   */
  castMenu (list) {
    const menu = []
    const keys = {}
    for (let i = 0; i < list.length; i++) {
      const item = list[i]
      if (item.parent) {
        keys[item.parent].children.push(item)
      } else {
        item.children = []
        menu.push(item)
        keys[item._id] = item
      }
    }
    return menu
  }
}
